import { action } from 'typesafe-actions';
import { ActionInterface } from 'common/action.interface';
import { asyncAction } from 'store/utils/promiseAction';
import { UserIpInterface, UserIpsTypes } from './types';

// List User Ips
export const listUserIpsRequest = (payload: {
  body?: object;
  filtering?: boolean;
}) => action(UserIpsTypes.LIST_USER_IPS_REQUEST, payload);
export const listUserIpsSuccess = (payload: {
  userIpsList: UserIpInterface[];
  totalCount: number;
}) => action(UserIpsTypes.LIST_USER_IPS_SUCCESS, payload);
export const listUserIpsFailure = () =>
  action(UserIpsTypes.LIST_USER_IPS_FAILURE);

// Get User Ip
export const getUserIpRequest = (payload: object) =>
  asyncAction(UserIpsTypes.GET_USER_IP_REQUEST, payload);
export const getUserIpSuccess = (payload: { userIpData: UserIpInterface }) =>
  action(UserIpsTypes.GET_USER_IP_SUCCESS, payload);
export const getUserIpFailure = () => action(UserIpsTypes.GET_USER_IP_FAILURE);

// Filter User Ips
export const filterUserIpsRequest = (payload: object) =>
  action(UserIpsTypes.FILTER_USER_IPS_REQUEST, payload);
export const filterUserIpsSuccess = (payload: {
  userIpsList: UserIpInterface[];
  totalCount: number;
}) => action(UserIpsTypes.FILTER_USER_IPS_SUCCESS, payload);
export const filterUserIpsFailure = () =>
  action(UserIpsTypes.FILTER_USER_IPS_FAILURE);

// Create User Ip
export const createUserIpRequest = (
  payload: object,
  dispatchOnSuccess?: ActionInterface,
) =>
  action(UserIpsTypes.CREATE_USER_IP_REQUEST, payload, { dispatchOnSuccess });
export const createUserIpSuccess = () =>
  action(UserIpsTypes.CREATE_USER_IP_SUCCESS);
export const createUserIpFailure = () =>
  action(UserIpsTypes.CREATE_USER_IP_FAILURE);

// Create List User Ips
export const createListUserIpsRequest = (
  payload: Array<object>,
  dispatchOnSuccess?: ActionInterface,
) =>
  action(UserIpsTypes.CREATE_USER_IP_REQUEST, payload, { dispatchOnSuccess });
export const createListUserIpsSuccess = () =>
  action(UserIpsTypes.CREATE_USER_IP_SUCCESS);
export const createListUserIpsFailure = () =>
  action(UserIpsTypes.CREATE_USER_IP_FAILURE);

// Update User Ip
export const updateUserIpRequest = (
  payload: object,
  dispatchOnSuccess?: ActionInterface,
) =>
  action(UserIpsTypes.UPDATE_USER_IP_REQUEST, payload, { dispatchOnSuccess });
export const updateUserIpSuccess = () =>
  action(UserIpsTypes.UPDATE_USER_IP_SUCCESS);
export const updateUserIpFailure = () =>
  action(UserIpsTypes.UPDATE_USER_IP_FAILURE);

// Delete User Ip
export const deleteUserIpRequest = (
  payload: object,
  dispatchOnSuccess?: ActionInterface,
) =>
  action(UserIpsTypes.DELETE_USER_IP_REQUEST, payload, { dispatchOnSuccess });
export const deleteUserIpSuccess = () =>
  action(UserIpsTypes.DELETE_USER_IP_SUCCESS);
export const deleteUserIpFailure = () =>
  action(UserIpsTypes.DELETE_USER_IP_FAILURE);
